import * as React from 'react';
import { Image } from '@cian/ui-kit';

import * as styles from './PromoItemIcon.css';
import { PROMO_ICON } from '../../constants/promoIcon';
import { IPromo } from '../../types/newbuilding/promos';

interface IPromoItemIconProps {
  promo: IPromo;
}

export function PromoItemIcon({ promo }: IPromoItemIconProps) {
  const { authorLogoUrl, promoType, isBlackFriday } = promo;

  const isAuthorLogoVisible = isBlackFriday && authorLogoUrl;
  const icon = isAuthorLogoVisible ? authorLogoUrl : PROMO_ICON.get(promoType);

  return (
    <div className={styles['container']}>
      <div className={styles['icon']}>
        {isAuthorLogoVisible ? (
          <Image src={authorLogoUrl} alt="logo" borderRadius="50%" objectFit="contain" />
        ) : (
          <img src={icon} alt="logo" />
        )}
      </div>
    </div>
  );
}
